module.exports = __webpack_public_path__ + "img/pic_special5.75b09119.png";